"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClassicPromotedContent = void 0;

require("core-js/modules/es6.function.name");

var _palette = require("@artsy/palette");

var _react = _interopRequireDefault(require("react"));

var _Responsive = require("../../../../../Utils/Responsive");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClassicPromotedContent = function ClassicPromotedContent(props) {
  var _props$article = props.article,
      partner = _props$article.partner,
      sale = _props$article.sale;
  var name = partner ? partner.name : sale && sale.name;
  var image = partner ? partner.profile.image.cropped.url : sale && sale.cover_image.cropped.url;
  var href = partner ? partner.profile.href : sale && sale.href;
  return _react.default.createElement(_palette.Box, {
    px: (0, _palette.space)(2),
    maxWidth: [1250],
    mx: "auto"
  }, _react.default.createElement(_palette.Flex, {
    justifyContent: "space-between",
    mb: (0, _palette.space)(2),
    alignItems: "center"
  }, _react.default.createElement(_palette.Flex, null, _react.default.createElement(_Responsive.Media, {
    greaterThan: "xs"
  }, _react.default.createElement("a", {
    href: href
  }, _react.default.createElement(_palette.Image, {
    src: image,
    width: "100px",
    mr: (0, _palette.space)(2)
  }))), _react.default.createElement(_palette.Flex, {
    flexDirection: "column"
  }, _react.default.createElement(_palette.Sans, {
    size: ["3", "4"],
    weight: "medium"
  }, _react.default.createElement(_palette.Link, {
    href: href,
    underlineBehavior: "none"
  }, "Promoted Content")), _react.default.createElement(_palette.Serif, {
    size: ["4", "5"]
  }, _react.default.createElement(_palette.Link, {
    href: href,
    noUnderline: true
  }, name)))), _react.default.createElement(_Responsive.Media, {
    greaterThan: "xs"
  }, _react.default.createElement("a", {
    href: href
  }, _react.default.createElement(_palette.Button, {
    variant: "secondaryOutline"
  }, "Explore ", partner ? "Gallery" : "Auction"))), _react.default.createElement(_Responsive.Media, {
    at: "xs"
  }, _react.default.createElement("a", {
    href: href
  }, _react.default.createElement(_palette.ArrowRightIcon, null)))), _react.default.createElement(_palette.Separator, {
    color: "black60"
  }));
};

exports.ClassicPromotedContent = ClassicPromotedContent;
//# sourceMappingURL=ClassicPromotedContent.js.map